// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","gridContainer":"App_gridContainer__ALkEu"};